import {useState} from 'react'
import DashBoardSideBar from '../Dashboard/LeftSideMenu';
import '../../pages/Dashboard/Dashboard.scss'

const HOC = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
      setIsMenuOpen(prevState => !prevState);
    };
  return (
    <section className='dashboad-section-page'>
      <DashBoardSideBar isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
      <section
        className={`dashboard-right-section ${isMenuOpen ? 'open' : 'closed'}`}
      >
        <div className='mobile-head'>
          <span className='togle' onClick={toggleMenu}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='32'
              height='32'
              fill='rgba(0,0,0,1)'
            >
              <path d='M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z'></path>
            </svg>
            {isMenuOpen ? 'Menu' : 'Menu'}
          </span>
        </div>
        {props.children}
      </section>
    </section>
  );
}


export default HOC